import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { DataViewModule } from "primeng/dataview";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";

import { VppOperatorComponent } from "./vpp-operator/vpp-operator.component";
import { VppPreRegisterComponent } from "./vpp-pre-register/vpp-pre-register.component";
import { Vpp3Component } from "./components/vpp3.component";
import { VppOperatorLookupComponent } from "./vpp-operator-lookup/vpp-operator-lookup.component";
import { DataService_VppOperatorLookup } from "./vpp-operator-lookup/shared/data.service";
import { DataService_VppOperator } from "./vpp-operator/shared/data.service";

@NgModule({
	declarations: [Vpp3Component, VppOperatorComponent, VppPreRegisterComponent, VppOperatorLookupComponent],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		SchoolselectorModule,
		DataViewModule,
	],
	providers: [ConfirmationService, DataService_VppOperator, DataService_VppOperatorLookup],
})
export class Vpp3Module {}
